import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  FormFeedback,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { signatoryValidationSchema } from "./utils/validations";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { documentTypes } from "../../../../utility/helpers";
import CustomDate from '../../../components/date-picker';


const SocietyFormModal = ({ isOpen, toggle, onSubmit, initialData }) => {
  const { list, loading } = useSelector((state) => state.companyPositions);
  const dispatch = useDispatch();
  const { societies } = useSelector((state) => state.signatories);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signatoryValidationSchema),
    defaultValues: {
      name: "",
      taxId: "",
      status: true,
    },
  });

  useEffect(() => {
    if (initialData) {
      reset(initialData);
    } else {
      reset({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        documentClient: "",
        identificationTypeId: null,
        birthDate: null,
        societyId: null,
        positionId: null,
      })
    }
  }, [initialData, reset]);

  const positionOptions = list.map((position) => ({
    value: position.id,
    label: position.name,
  }));


  const onSubmitForm = (data) => {
    onSubmit(data);
    toggle(); // Cerrar modal después de enviar
    reset(); // Limpiar formulario
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {initialData ? "Editar Firmante" : "Crear Nuevo Firmante"}
      </ModalHeader>
      <Form onSubmit={handleSubmit(onSubmitForm)}>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup>
                <Label for="firstName">Nombre</Label>
                <Controller
                  name="firstName"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      id="firstName"
                      className={`form-control ${
                        errors.firstName ? "is-invalid" : ""
                      }`}
                      placeholder="Ingrese el Nombre"
                    />
                  )}
                />
                {errors.firstName && (
                  <div className="invalid-feedback">
                    {errors.firstName.message}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="name">Apellidos</Label>
                <Controller
                  name="lastName"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      id="lastName"
                      className={`form-control ${
                        errors.lastName ? "is-invalid" : ""
                      }`}
                      placeholder="Ingrese Apellido"
                    />
                  )}
                />
                {errors.lastName && (
                  <div className="invalid-feedback">
                    {errors.lastName.message}
                  </div>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="phone">Teléfono</Label>
                <Controller
                  name="phone"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      id="phone"
                      className={`form-control ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                      placeholder="Ingrese el Teléfono"
                    />
                  )}
                />
                {errors.phone && (
                  <div className="invalid-feedback">{errors.phone.message}</div>
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label for="email">Email</Label>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      id="email"
                      className={`form-control ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Ingrese el Email"
                    />
                  )}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="documentClient">Documento</Label>
                <Controller
                  name="documentClient"
                  control={control}
                  render={({ field }) => (
                    <input
                      {...field}
                      id="documentClient"
                      className={`form-control ${
                        errors.documentClient ? "is-invalid" : ""
                      }`}
                      placeholder="Ingrese el Documento"
                    />
                  )}
                />
                {errors.documentClient && (
                  <div className="invalid-feedback">
                    {errors.documentClient.message}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label className="form-label" for="identificationTypeId">
                  Tipo de documento*
                </Label>
                <Controller
                  id="identificationTypeId"
                  name="identificationTypeId"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isClearable={false}
                      className={`dataTable-filter ${
                        errors.identificationTypeId ? "is-invalid" : ""
                      }`}
                      classNamePrefix="select"
                      options={documentTypes}
                    />
                  )}
                />
                {errors.identificationTypeId && (
                  <FormFeedback>
                    Por favor seleccione un tipo de documento valido
                  </FormFeedback>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6" className="mb-1">
              <Label className="form-label" for="birthDate">
                Fecha de nacimiento
              </Label>
              <Controller
                id="birthDate"
                name="birthDate"
                control={control}
                render={({ field }) => (
                  <CustomDate
                    {...field}
                    error={errors?.birthDate?.message}
                    disableDay={false}
                  />
                )}
              />
              {errors.birthdate && (
                <FormFeedback>
                  {errors.birthDate.message ? (
                    <strong>{errors.birthdate.message}</strong>
                  ) : (
                    "La fecha de nacimiento es obligatoria"
                  )}
                </FormFeedback>
              )}
            </Col>
            <Col>
              <FormGroup>
                <Label for="societyId">Sociedad</Label>
                <Controller
                  name="societyId"
                  control={control}
                  render={({ field }) => (
                    <>
                    <Select
                      {...field}
                      id="societyId"
                      className={`dataTable-filter ${
                        errors.societyId ? "is-invalid" : ""
                      }`}
                      classNamePrefix="select"
                      options={societies}
                    />
                    {errors.societyId && (
                      <FormFeedback className="invalid-feedback">
                        {errors.societyId.message}
                      </FormFeedback>
                    )}
                    </>
                  )}
                />
                
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label for="positionId">Posición</Label>
                <Controller
                  name="positionId"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      id="positionId"
                      className={`dataTable-filter ${
                        errors.positionId ? "is-invalid" : ""
                      }`}
                      classNamePrefix="select"
                      options={positionOptions}
                    />
                  )}
                />
                {errors.positionId && (
                  <div className="invalid-feedback">{errors.positionId.message}</div>
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button color="primary" type="submit">
            {initialData ? "Guardar Cambios" : "Crear"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default SocietyFormModal;
